import { md5 } from './index';
const gData = {
  cache: {},
  timeRange: 500,
  enableCache: false,
  clearInterval: 60000
};

function type(o) {
  return Object.prototype.toString.apply(o);
}
function isObj(o) {
  return type(o) === '[object Object]';
}

function isArray(o) {
  return type(o) === '[object Array]';
}

function sortFn(a, b) {
  a = String(a);
  b = String(b);
  var l = Math.min(a.length, b.length);
  var res = 0;
  for (var i = 0; i < l; i++) {
    res = a.charCodeAt(i) - b.charCodeAt(i);
    if (res !== 0) {
      break;
    }
  }
  return res;
}

function isString(o) {
  return type(o) === '[object String]';
}

function printAtom(o) {
  return isString(o) ? ['\'', o, '\''].join('') : o;
}

/*
* o:待转换对象
* res:字符串缓存数组
* key:当前待转换对象在上级中的key
* hasPre:当前元素是否有兄弟节点
* */
function toPlanString(o, res, key, hasPre) {
  if (isArray(o)) {
    res.push((hasPre ? ',' : '') + (key ? (key + ':') : key) + '[');
    for (let i = 0, l = o.length; i < l; i++) {
      toPlanString(o[i], res, '', i > 0);
    }
    res.push(']');
  } else if (isObj(o)) {
    res.push((hasPre ? ',' : '') + (key ? (key + ':') : key) + '{');
    // 对key进行排序
    var keys = Object.keys(o).sort(sortFn);
    let added = 0;
    for (let i = 0, l = keys.length; i < l; i++) {
      if (o[keys[i]] === undefined) {
        continue;
      }
      added++;
      toPlanString(o[keys[i]], res, keys[i], added > 1);
    }
    res.push('}');
  } else {
    res.push((hasPre ? ',' : '') + (key ? (key + ':') : key) + printAtom(o));
  }
  return res.join('');
}

// 包装调用生成字符串
function toString(o) {
  return toPlanString(o, [], '', false);
}

function inTimeRange(pre) {
  return pre && pre.time >= Date.now();
}

function getPreRequest(key, url, method, data) {
  const pre = gData.cache[key];
  let res = null;
  if (inTimeRange(pre)) {
    pre.usedTime++;
    res = pre.result;
  } else {
    gData.cache[key] = {
      usedTime: 0,
      url,
      method,
      data,
      time: Date.now() + gData.timeRange,
      result: null
    };
  }
  return res;
}

function recordRequest(key, res) {
  const cur = gData.cache[key];
  if (cur) {
    cur.result = res;
  } else {
    throw Error('缓存结果存储失败！');
  }
}

function cacheClear() {
  const cache = gData.cache;
  const res = {};
  const now = Date.now();
  Object.keys(cache).forEach(k => {
    const cur = cache[k];
    if (cur.time > now) {
      res[k] = cur;
    }
  });
  gData.cache = res;
  setTimeout(cacheClear, gData.clearInterval);
}

function requestCache(request, enable) {
  if (!enable) {
    return request;
  }
  gData.enableCache = enable;
  gData.request = request;
  // response interceptor
  function wrappService() {
    const args = arguments;
    if (gData.enableCache) {
      const cfg = args[0];
      const md5str = md5(toString(cfg.data));
      const key = `${cfg.url}_${cfg.method}_${md5str}`;
      // 获取前一时段内的结果
      const preRes = getPreRequest(key, cfg.url, cfg.method, cfg.data);
      if (preRes) {
        console.log(`从缓存中获取数据: ${key}`);
        return preRes;
      } else {
        const p = request.apply(request, args);
        recordRequest(key, p);
        return p;
      }
    } else if (request) {
      return request.apply(request, args);
    } else {
      throw Error('http请求出错！');
    }
  }
  setTimeout(cacheClear, gData.clearInterval);
  return new Proxy(wrappService, {
    get: function(target, attr) {
      return request[attr];
    }
  });
}

window.xesHttpRequestCache = function() {
  console.log(gData);
};

window.xesHttpRequestCacheUsed = function() {
  const { cache } = gData;
  const res = {};
  Object.keys(cache).forEach(k => {
    const cur = cache[k];
    if (cur.usedTime > 0) {
      res[k] = cur;
    }
  });
  console.log(res);
};
export default requestCache;
